const comments = [
  {
    name: '追剧达人小王',
    avatar: '王',
    rating: 5,
    text: '用了6080新视觉影院大半年了，画质真的没话说，最新电视剧高清不卡顿，加载速度秒开，免费看全集太香了！推荐给身边所有追剧朋友。',
    time: '3 天前',
  },
  {
    name: '深夜煲剧人',
    avatar: '夜',
    rating: 5,
    text: '对比了好几个平台，6080的流畅度确实突出，不缓冲不卡顿，界面也干净。最近更新的几部热播剧资源同步很快，点赞！',
    time: '1 周前',
  },
  {
    name: '剧荒拯救者',
    avatar: '剧',
    rating: 4,
    text: '资源真的很全，国产剧、韩剧、美剧都有，找了一圈终于在这里找到了全集免费在线观看。希望继续更新更多经典老剧资源。',
    time: '2 周前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/10 border border-accent-500/20 mb-4">
            <i className="ri-chat-3-line text-accent-500 text-sm"></i>
            <span className="text-accent-400 text-xs font-medium">观众评价</span>
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">剧迷真实反馈</h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-xl mx-auto">
            来自观众的真诚评价，高清流畅免费追剧体验得到一致认可
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {comments.map((c, i) => (
            <div
              key={i}
              className="bg-background-100 border border-background-200/60 rounded-xl p-5 hover:border-primary-500/20 transition-colors"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-500/15 flex items-center justify-center">
                  <span className="text-primary-500 font-bold text-sm">{c.avatar}</span>
                </div>
                <div>
                  <div className="text-foreground-800 font-semibold text-sm">{c.name}</div>
                  <div className="flex items-center gap-0.5 mt-0.5">
                    {Array.from({ length: 5 }).map((_, j) => (
                      <i
                        key={j}
                        className={`text-xs ${j < c.rating ? 'ri-star-fill text-primary-500' : 'ri-star-line text-foreground-400'}`}
                      ></i>
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-foreground-500 text-sm leading-relaxed">{c.text}</p>
              <div className="mt-3 text-foreground-400 text-xs">{c.time}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}